import { fromBaseClone } from './from-base-context';

/** Cold hosts own plain mutable trees. Frame callers pass only the changed
 * payload, so isolating a host never copies its held encounter on a delta. */
export function mutableSurface<T>(value: T, omitKeys?: ReadonlySet<string>): T {
    return fromBaseClone(value, undefined, true, omitKeys);
}
